/**
 * Guía: Mis Pagos.
 *
 * Contenido derivado del capítulo **37** del manual: §0 (qué hay aquí y qué
 * no puede hacer el asesor) y §2 (el ciclo de su cuenta bancaria y el
 * bloqueo al aprobarse).
 *
 * El paso del bloqueo es el que evita un reclamo recurrente: la cuenta
 * aprobada no la edita su dueño, y el motivo no es burocracia.
 */

import type { TourFlow } from '../types';

const MIS_PAGOS_PATH = '/my-advisor-payouts';

export const c37MisPagos: TourFlow = {
  id: 'admin.my-advisor-payouts',
  chapter: '37',
  title: 'Mis pagos',
  summary:
    'Dónde y cuándo cobras: tu cuenta bancaria, por qué se bloquea al aprobarse y qué no puedes hacer.',
  href: MIS_PAGOS_PATH,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'Dónde y cuándo cobras',
      body:
        'Mis Comisiones es lo que has ganado; ésta es dónde llega. Dos cosas: tus cuentas ' +
        'bancarias y el historial de tus pagos.',
      route: MIS_PAGOS_PATH,
    },
    {
      id: 'account-locks',
      title: 'Una cuenta aprobada ya no la editas tú',
      body:
        'Se registra, queda en revisión y, cuando finanzas la aprueba, se bloquea. Para ' +
        'cambiarla se abre un ticket. No es burocracia: si el dueño pudiera cambiarla ' +
        'libremente, tomarle la sesión un minuto antes de una liquidación bastaría para ' +
        'desviar su dinero. Si te la rechazan, sí puedes corregirla.',
      target: 'admin.myPayouts.tabs',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'default-account',
      title: 'La que cuenta es la principal',
      body:
        'Se transfiere a la cuenta marcada como principal, y tiene que estar aprobada. Tener ' +
        'otra aprobada que no sea la principal no sirve para cobrar.',
    },
    {
      id: 'cannot-request',
      title: 'Los pagos no se piden desde aquí',
      body:
        'Los genera el equipo en su calendario: no se puede crear ni cancelar uno. Esta ' +
        'pantalla es para consultarlos.',
    },
  ],
};
